import React from 'react'
import { Typography, Stack, Box, Grid,  } from '@mui/material'
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import FieldLabel from './FieldLabel';

function FieldRemitos({
    remitosTexto,
    cliente
}) {
  return (
    <div>
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md>
              <FieldLabel icon={<ReceiptLongIcon sx={{ fontSize: 16 }} />}>
                Remitos
              </FieldLabel>
              <Box
                sx={{
                  mt: 0.5,
                  p: 1.25,
                  borderRadius: 2,
                  bgcolor: "action.hover",
                  border: "1px dashed",
                  borderColor: "divider",
                  minHeight: 44,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "text.primary", fontSize: 15 }}
                >
                  {remitosTexto || "Sin remitos seleccionados"}
                </Typography>
              </Box>
              {cliente?.pesada_cliente === 0 && (
                <Stack
                  direction="row"
                  spacing={0.75}
                  alignItems="center"
                  sx={{ mt: 1, color: "error.main" }}
                >
                  <WarningAmberIcon sx={{ fontSize: 16 }} />
                  <Typography variant="body2" sx={{ fontSize: 13.5 }}>
                    Facturación según pesada de cliente.
                  </Typography>
                </Stack>
              )}
            </Grid>
    
            {/* <Grid item xs={12} md="auto">
              <Button
                variant="contained"
                color="success"
                fullWidth
                size="large"
                startIcon={<CheckCircleOutlineIcon />}
                onClick={confirmar}
                disabled={facturarDeshabilitado}
                sx={{
                  minWidth: { md: 200 },
                  py: 1.25,
                  fontWeight: 700,
                  borderRadius: 2,
                  boxShadow: "none",
                }}
              >
                PREVISUALIZAR
              </Button>
            </Grid> */}
          </Grid>
      
    </div>
  )
}

export default FieldRemitos
